import { ValidationModel, ValidationType } from "@/services/validation/types";
import { Vue } from "vue-property-decorator";

export function addFontValidators(validators: any, id: string) {
    Vue.set(validators,
        `technicalName-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
    Vue.set(validators,
        `displayName-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
}

export function removeFontValidators(validators: any, id: string) {
    Vue.delete(validators,
        `technicalName-${id}`);
    Vue.delete(validators,
        `displayName-${id}`);
}
